/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Cmp_R_Maturity_PcInputs */

const en_pc_cmp_r_maturity_pc = /** @type {(inputs: Pc_Cmp_R_Maturity_PcInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha, v${i?.version}. About 55% of the way to replacing Acrobat for everyday work, by the project's own count`)
};

const zh_pc_cmp_r_maturity_pc = /** @type {(inputs: Pc_Cmp_R_Maturity_PcInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha 阶段，v${i?.version}。按项目自评，日常工作约达到替代 Acrobat 的 55%`)
};

/**
* | output |
* | --- |
* | "Alpha, v{version}. About 55% of the way to replacing Acrobat for everyday work, by the project's own count" |
*
* @param {Pc_Cmp_R_Maturity_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_maturity_pc = /** @type {((inputs: Pc_Cmp_R_Maturity_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Maturity_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_maturity_pc(inputs)
	return zh_pc_cmp_r_maturity_pc(inputs)
});
export { pc_cmp_r_maturity_pc as "pc.cmp.r.maturity.pc" }